import { render, staticRenderFns } from "./OsPreventiva.vue?vue&type=template&id=4f50d600&"
import script from "./OsPreventiva.vue?vue&type=script&lang=js&"
export * from "./OsPreventiva.vue?vue&type=script&lang=js&"
import style0 from "./OsPreventiva.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports